export function set(key, value) {
    const anyWindow = window;
    anyWindow.jh = anyWindow.jh || {};
    anyWindow.jh[key] = value;
}
export function get(key) {
    const anyWindow = window;
    anyWindow.jh = anyWindow.jh || {};
    return anyWindow.jh[key];
}
//# sourceMappingURL=global.js.map